// import { createBrowserHistory } from 'history';

// export default createBrowserHistory({
//     // optional configuration object here
// });

import { createBrowserHistory } from "history";

export const history = createBrowserHistory();
